module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_85-d9a8d74f3802da23ccf44526164a9722.png";